import { ArcademicsResponse } from "./game-arcademics"
import { CountryId } from "../../common/country"

export interface ActivityGameData<Meta, PMeta> {
  id: number;
  providerId: string;
  providerGameId: string;
  name: string;
  link: string;
  subject: string;
  image: string;
  description: string;
  metadata: Meta;
  metadataProvider: PMeta;
}

export abstract class ActivityGame<Meta = any, PMeta = any> implements ActivityGameData<Meta, PMeta> {

  abstract getYearLevels(country: CountryId): string;

  constructor(protected data: ActivityGameData<Meta, PMeta>) {
  }

  get id() {
    return this.data.id
  }

  get providerId() {
    return this.data.providerId
  }

  get providerGameId() {
    return this.data.providerGameId
  }

  get name() {
    return this.data.name
  }

  get subject() {
    return this.data.subject
  }

  get link() {
    return this.data.link
  }

  get image() {
    return this.data.image
  }

  get subtitle() {
    return this.data.subject
  }

  get description() {
    return this.data.description
  }

  get metadata() {
    return this.data.metadata
  }

  get metadataProvider() {
    return this.data.metadataProvider
  }
}

interface Metadata {
  ukLevels: string[];
  nzLevels: string[];
}

interface ArcademicsProviderMetadata {
  subject: string;
  description: string;
  grades: string[];
  categories: string[];
  content: string;
  players: number;
  customizableContent: boolean;
}

export class ArcademicsGame extends ActivityGame<Metadata, ArcademicsProviderMetadata> {
  constructor(protected data: any) {
    if (data.providerId !== GameProvider.ARCADEMICS) {
      throw new Error(`wrong providerId. expected arcademics but got ${data.providerId}`)
    }
    super(data)
  }

  getYearLevels(country: CountryId): string {
    if(country === CountryId.UK)
      return (this.metadata.ukLevels || []).join(', ');
    else if(country === CountryId.NZ)
      return (this.metadata.nzLevels || []).join(', ');
    else
      return (this.metadata.ukLevels || []).join(', ');
  }

}

export const GameProvider = {
  ARCADEMICS: 'arcademics',
  MYGOOROO: 'mygooroo'
}

export interface GameAttempt {
  id: number;
  fk_lesson_key: string;
  fk_lesson_activity_key: string;
  fk_student_key: string;
  fk_ses_key: string;
  provider_id: string;
  provider_game_id: string;
  created_on: string;
  updated_on: string;
  provider_response: ArcademicsResponse[];
}

export const GameMetatdata = {
  coinsPerGame: 2
}
